<script>
  import { site } from './store.js'
</script>

<div class="sites">
  <div class="menu-top-menu-container">
    <div class="portal fr"><a class="tdn" href="https://www.theaero.com/status/hub/sunvair"><i class="fas fa-paper-plane"></i> Customer Portal</a></div>
    <ul id="menu-top-menu" class="menu">
      <li class:current={ $site.code == 'sunvairgroup' }><a href="/" class="menu-image-title-after">SUNVAIR AEROSPACE GROUP</a></li>
      <li class:current={ $site.code == 'sunvair' }><a href="https://www.sunvair.aero/" class="">Sunvair</a></li>
      <li class:current={ $site.code == 'aaic' }><a href="https://www.aaic.aero/" class="">AAIC</a></li>
      <li class:current={ $site.code == 'plating' }><a href="https://www.aerospaceplating.com/" class="">Aerospace Plating</a></li>
    </ul>
  </div>
</div>

<style>
.sites {
	background: #0080d0;
}
.portal{
	padding: 12px 2.8rem 0 2.9rem;
	font-size: 14px;
  line-height: 16px;
}
.portal a{
  color: #fff;
}
.fixed-menu .sites {
  transform: translate(0, -40px);
}
.sites ul {
	list-style-type: none;
}
.sites ul li {
	display: inline-block;
	vertical-align: top;
	font-size: 1.4rem;
  line-height: 16px;
}
.sites ul li a {
	padding: 12px 2.8rem 12px 2.9rem;
	display: block;
	color: #fff;
	text-decoration: none;
  letter-spacing: 1px;
  word-spacing: -1px;
  transition: background .35s, color .35s;
}
.sites ul li:first-child a {
	font-weight: 900;
}
.sites ul li.current a,
.sites ul li a:hover,
.sites ul li a:focus  {
	background: #fff;
	color: #535353;  
}
.sites ul li.test a:focus {
  background: none;
  color: #fff;
}
.sites ul li.current a {
  font-weight: bold;
}
</style>
